<template>
	<thead style="border-bottom: 0 !important; position: -webkit-sticky; position: sticky; top: 0; z-index: 2;">
		<tr style="display:flex; width: 100%; height: 30px; justify-content: space-between; align-items: center;">
			<th class="px-0" style="height: 30px; border-right: 1px solid #ddd; min-width: 125px;"></th>
			<th class="px-0" v-for="h in headers" :key="h.value" style="height: 30px; width: 100%; padding: 0; border-right: 1px solid #ddd; font-size: 0.7em !important; text-align: center !important; text-transform: uppercase !important; display: flex; justify-content: center; align-items: center;">
			<span :style="'margin: 0; padding: 5px !important; text-align: center !important;' + (h.isToday ? 'background: #185EA9 !important; border-radius: 30px !important; color: #fff !important; margin-bottom: 2px;' : '')">
				{{ h.text }}
			</span>
			</th>
		</tr>
	</thead>
</template>

<script>
import BaseModule from '../BaseModule';

export default {
	name: 'CalendarHeader',
	mixins: [BaseModule],
	data () {
		return {
			headers: []
		}
	},
	methods: {		
		createHeader(fromDate, toDate, view, showSummary) {
			let day = new Date(fromDate);
			let lastDay = new Date(toDate);

			this.headers = [];

			while (day <= lastDay) {
				this.headers.push({ text: this.dayName(view, day), value: day.toISOString(), sortable: false, isToday: this.isToday(day) });
				day = this.addDaysToDate(day, 1);
			}

			if (showSummary) {
				this.headers.push({ text: this.$t('wkt.admin.holidays.calendar.edit-holiday-window.table.headers.total'), value: '', sortable: false, isToday: false });
			}
		},
		dayName(view, day) {
			if (view === 0) {
				return `${day.toLocaleString([this.$i18n.locale, 'en'], { weekday: 'long' }).slice(0, 1).toUpperCase()}${day.getDate()}`;
			} else if (view === 1) {
				return `${day.toLocaleString([this.$i18n.locale, 'en'], { weekday: 'short', day: 'numeric', month: 'short' })}`;
				//return `${day.toLocaleString([this.$i18n.locale, 'en'], { weekday: 'short' })} ${${day.toLocaleString('es', { day: '2-digit' })} ${day.toLocaleString('es', { month: 'short' })}`;
			}
		},
	}
}
</script>